import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import LoadingButton from '../../components/LoadingButton';
import PageLayout from '../../components/PageLayout';
import SelectLoadingFetch from '../../components/SelectLoadingFetch';
import analytics from '../../lib/analytics';
import useCountries from '../../lib/hooks/useCountries';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const HabitualResidenceCountryPage = ({
  initialHabitualResidenceCountry,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const [habitualResidenceCountry, setHabitualResidenceCountry] = useState(
    initialHabitualResidenceCountry,
  );

  const isInvalid = habitualResidenceCountry === null || habitualResidenceCountry === undefined;

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'habitual-residence');

    const { value: countryOfHabitualResidenceCode } = habitualResidenceCountry;
    dispatchAddPageData(
      payloadFactory.createAddPageDataPayload(
        'countryOfHabitualResidence',
        habitualResidenceCountry,
        'countryOfHabitualResidenceCode',
        countryOfHabitualResidenceCode,
      ),
    );

    dispatchWizardNav({ dir: 'fwd', resetState: true });
  };

  const setCountry = country => setHabitualResidenceCountry(country);

  useEffect(() => {
    // Prevent the input field from automatically receiving focus when the component mounts
    const inputField = document.querySelector('input');
    if (inputField) {
      inputField.blur();
    }
  }, []);

  return (
    <PageLayout
      title="What country do you consider your home?"
      helpText="This is the country where you have a right to live and work, and that you consider your home country."
    >
      <form onSubmit={handleSubmit}>
        <SelectLoadingFetch
          single="country"
          plural="countries"
          onChange={setCountry}
          selected={habitualResidenceCountry}
          hook={useCountries}
          label="Country"
        />

        <div className="mt-12">
          <LoadingButton type="submit" className="niso-button" isDisabled={isInvalid}>
            Next
          </LoadingButton>
        </div>
      </form>
    </PageLayout>
  );
};

HabitualResidenceCountryPage.propTypes = {
  initialHabitualResidenceCountry: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

HabitualResidenceCountryPage.defaultProps = {
  initialHabitualResidenceCountry: null,
};

export const mapStateToProps = state => ({
  initialHabitualResidenceCountry: state.builder.ui.countryOfHabitualResidence,
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { HabitualResidenceCountryPage };

export default connect(mapStateToProps, mapDispatchToProps)(HabitualResidenceCountryPage);
